var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[(!_vm.isAuthorized)?_c('v-icon',{attrs:{"x-large":""}},[_vm._v("lock")]):_c('span',{staticClass:"display-1 grey--text"},[_vm._v("Добро пожаловать в административную панель")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }